export const CASH_FLOW_ASSET_BASIC_INFO = 'CASH_FLOW_ASSET_BASIC_INFO';
export const CASH_FLOW_LIST = 'CASH_FLOW_LIST';
export const CASHFLOW_WIDGET = 'CASHFLOW_WIDGET';
export const CASHFLOW_LOADER = 'CASHFLOW_LOADER';
